import React, { useState, useEffect } from "react";
import VjsTable from "./components/VjsTable";
import api from "services/api";

const Vjs = () => {
  const [vjs, setVjs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [name, setName] = useState("");
  const [toast, setToast] = useState({ show: false, message: "", type: "success" });

  const showToast = (message, type = "success") => {
    setToast({ show: true, message, type });
    setTimeout(() => setToast({ show: false, message: "", type: "success" }), 3000);
  };

  const fetchVjs = async () => {
    try {
      const res = await api.getVjs();
      if (Array.isArray(res)) setVjs(res);
    } catch (err) {
      console.error("Failed to fetch VJs:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVjs();
  }, []);

  const handleAdd = () => {
    setEditData(null);
    setName("");
    setShowModal(true);
  };

  const handleEdit = (vj) => {
    setEditData(vj);
    setName(vj.name);
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this VJ?")) return;
    try {
      await api.deleteVj(id);
      showToast("VJ deleted successfully!");
      fetchVjs();
    } catch (error) {
      showToast("Failed to delete VJ", "error");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editData) {
        await api.updateVj(editData.id, { name });
        showToast("VJ updated successfully!");
      } else {
        await api.createVj({ name });
        showToast("VJ created successfully!");
      }
      setShowModal(false);
      fetchVjs();
    } catch (error) {
      showToast(error.message || "Failed to save VJ", "error");
    }
  };

  return (
    <div>
      <div className="mt-5 flex w-full justify-end">
        <button
          onClick={handleAdd}
          className="linear rounded-[20px] bg-brand-500 px-4 py-2 text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:opacity-90"
        >
          + Add New VJ
        </button>
      </div>

      <div className="mt-5 grid h-full grid-cols-1 gap-5">
        <VjsTable tableData={vjs} onEdit={handleEdit} onDelete={handleDelete} />
      </div>

      {showModal && (
        <div className="fixed inset-0 z-[999] flex items-center justify-center p-4" style={{ backgroundColor: 'rgba(0,0,0,0.6)' }}>
          <div className="w-full max-w-md rounded-[20px] bg-white p-6 shadow-xl dark:!bg-navy-800">
            <h3 className="mb-4 text-xl font-bold text-navy-700 dark:text-white">
              {editData ? "Edit VJ" : "Add New VJ"}
            </h3>
            <form onSubmit={handleSubmit}>
              <div className="mb-4">
                <label className="mb-1 block text-sm font-medium text-navy-700 dark:text-white">
                  VJ Name
                </label>
                <input
                  type="text"
                  required
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className="mt-2 flex h-12 w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none border-gray-200 dark:!border-white/10 dark:text-white"
                  placeholder="e.g. VJ Jingo"
                />
              </div>
              <div className="flex justify-end gap-2">
                <button
                  type="button"
                  onClick={() => setShowModal(false)}
                  className="linear rounded-[20px] bg-gray-100 px-4 py-2 text-base font-medium text-navy-700 transition duration-200 hover:bg-gray-200 dark:bg-white/10 dark:text-white dark:hover:bg-white/20"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="linear rounded-[20px] bg-brand-500 px-4 py-2 text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:opacity-90"
                >
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {toast.show && (
        <div className={`fixed top-10 left-1/2 -translate-x-1/2 z-[1000] flex items-center rounded-xl px-6 py-3 text-sm font-bold text-white shadow-xl transition-all ${toast.type === 'success' ? 'bg-green-500' : 'bg-red-500'}`}>
          {toast.message}
        </div>
      )}
    </div>
  );
};

export default Vjs;
